import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from '../models/user';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({
  providedIn: 'root'
})
export class UserService {

  public host = environment.host;

  constructor(private httpClient: HttpClient) { }

  getAllUsers(): Observable<User[]> {
    const host = environment.host;
    return this.httpClient.get<User[]>(host + '/users', httpOptions);
  }

  searchUsers(searchKeyWords: string): Observable<User[]> {
    const host = environment.host;
    console.log("bb" + searchKeyWords);
    if (searchKeyWords) {
      /*return this.httpClient.get<User[]>(host + '/users?name_like=' + searchKeyWords);*/
      return this.httpClient.get<User[]>(host + '/users/searchUsers/' + searchKeyWords);
    } else {
      return this.httpClient.get<User[]>(host + '/users');
    }
  }

  getUserByName(name: string): Observable<User> {
    const host = environment.host;
      return this.httpClient.get<User>(host + '/users/getUserByName/' + name);
  }

   deleteUser(user: User): Observable<void> {
     const host = environment.host;
     return this.httpClient.delete<void>(host + '/users/' + user._id);
   }

  save(user: User): Observable<User> {
    const host = environment.host;
    return this.httpClient.post<User>(host + '/users/', user, httpOptions);
  }

  getUser(_id: string): Observable<User> {
    const host = environment.host;
    return this.httpClient.get<User>(host + '/users/' + _id, httpOptions);
  }

  updateUser(user: User): Observable<User> {
    const host = environment.host;
    return this.httpClient.put<User>(host + '/users/' + user._id, user, httpOptions);
  }

  login(username: string, password: string): Observable<User> {
    return this.httpClient.post<User>(this.host + '/login/public', { username, password });
  }

  inscription(user: User): Observable<User> {
    return this.httpClient.post<User>(this.host + '/users', user);
  }

  verifyEmail(token: string): Observable<{ verified: boolean }> {
    return this.httpClient.get<{ verified: boolean }>(this.host + '/users/verify-email/' + token);
  }

  forgotPassword(email: string): Observable<{ message: string }> {
    return this.httpClient.post<{ message: string }>(this.host + '/users/forgot-password', { email });
  }

  resetPassword(token: string, password: string): Observable<{ reset: boolean }> {
    return this.httpClient.post<{ reset: boolean }>(this.host + '/users/reset-password', { token, password });
  }
}

